import { useTrackSiteFilesAnalytics } from '../../../hooks/bi/useTrackSiteFilesAnalytics';
import { createHOCWithHookInside } from '../../createHOCWithHookInside';

/**
 * @deprecated use "useTrackSiteFilesAnalytics"
 */
export const withTrackSiteFilesAnalytics = createHOCWithHookInside(
  'WithTrackSiteFilesAnalytics',
  useTrackSiteFilesAnalytics,
);
